import { render, staticRenderFns } from "./NewFrontPage.vue?vue&type=template&id=67dd54b2"
import script from "./NewFrontPage.vue?vue&type=script&lang=js"
export * from "./NewFrontPage.vue?vue&type=script&lang=js"
import style0 from "./NewFrontPage.vue?vue&type=style&index=0&id=67dd54b2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports